import { gql, type OperationVariables } from '@apollo/client';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import Company from '@src/Objects/Company';
import { companySettingsGql } from '../Company/getCompanySettings';
import GraphQL from '../graphQL';

const query = gql`
mutation changeOULeader($id:Int!, $leader: Int!) {
    changeOULeader(id: $id,leader: $leader) 
    ${companySettingsGql}
},
`;

export default async function changeOULeader(id: number, leader: number) {
    const variables: OperationVariables = { id, leader };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((c) => new Company(c));
}
